// Tunable acceptance gates — the knobs the data-ops lead owns. These mirror the
// Python `GATES` dict in tools/qa/qa_session.py EXACTLY; they are pilot-tunable
// (see docs/STRATEGY.md §7). One obvious place to tune, kept in lockstep with
// the Python via core/test/parity.test.ts.
export const GATES = {
  min_duration_s: 1.0, // below this it's a misfire, not a take
  fps_target: 60.0, // FALLBACK only — the real target reads from meta *_fps_target_range (EGO-149)
  fps_warn_frac: 0.9, // warn if actual < 90% of target
  fps_fail_frac: 0.75, // fail if actual < 75% of target
  lr_frame_skew_max: 3, // |left_frames - right_frames|
  hand_uptime_warn: 0.9, // fraction of frames with a fully-valid hand
  hand_uptime_fail: 0.6,
  cam_uptime_warn: 0.95, // fraction of frames with a true camera world pose
  cam_uptime_fail: 0.8,
  wrist_speed_gate_mps: 6.0, // teleport detector (re-acquisition glitch)
  glitch_rate_warn: 0.01, // warn if >1% of frame-pairs teleport
  glitch_rate_fail: 0.05,
  depth_drop_warn: 1, // any dropped depth frame is a warn
  body_uptime_warn: 0.8, // only graded when body capture was on
} as const;

// joint 0 = Wrist, per meta.joint_order
export const WRIST_IDX = 0;
export const JOINTS = 26;
export const FLOATS_PER_JOINT = 7;
